import { IDateRange } from '../../types/common/DateRange';

function createSpeciesRowData(
  color: string,
  species: string,
  count: number,
  percentage: number,
) {
  return { color, percentage, species, count };
}

const windSpeedIndex: { [key: number]: [string, string] } = {
  0: ['0-5', 'km/h'],
  5: ['5-10', 'km/h'],
  10: ['10-15', 'km/h'],
  15: ['15-20', 'km/h'],
  20: ['20-25', 'km/h'],
  25: ['25-30', 'km/h'],
  30: ['30-35', 'km/h'],
  35: ['35-40', 'km/h'],
  40: ['40-45', 'km/h'],
  45: ['45-50', 'km/h'],
  50: ['50+', 'km/h'],
};

export const find_bin = (val: number, dateRange: IDateRange) => {
  // let minVal: number = 0;
  let diff_in_time = 30;
  if (dateRange.endDate && dateRange.startDate) {
    diff_in_time = dateRange.endDate.getTime() - dateRange!.startDate.getTime();
  }
  let maxVal: number = Math.ceil(diff_in_time / (1000 * 3600 * 24));

  let bin_length: number = maxVal / 5;
  let bins = [0];
  for (let bin = bin_length + 1; bin < maxVal; bin += bin_length) {
    bins.push(bin);
  }
  for (let i = 0, len = bins.length; i < len; i++) if (val <= bins[i]) return i;
  return 5;
};

export const getStackedBarColor = (val: number) => {
  let color = '#E8E8E8';
  if (val > 0 && val <= 4) {
    color = '#EFE5FC';
  } else if (val > 4 && val <= 8) {
    color = '#C7AFE7';
  } else if (val > 8 && val <= 12) {
    color = '#A07AD1';
  } else if (val > 12 && val <= 16) {
    color = '#7746B9';
  } else if (val > 16) {
    color = '#4903A1';
  }
  return color;
};

export const getReliablity = (val: number) => {
  let reliabilty = 0;
  if (val === 0) {
    reliabilty = 0;
  } else if (val > 0 && val <= 4) {
    reliabilty = 1;
  } else if (val > 4 && val <= 8) {
    reliabilty = 2;
  } else if (val > 8 && val <= 12) {
    reliabilty = 3;
  } else if (val > 12 && val <= 16) {
    reliabilty = 4;
  } else {
    reliabilty = 5;
  }
  return reliabilty;
};

export const mergeByDate = (...arrs: any[]) => {
  const result = arrs.flat().reduce((acc, obj) => {
    acc[obj.date] = {
      date: obj.date,
      number_of_birds:
        (acc[obj.date]?.number_of_birds ?? 0) + (obj?.number_of_birds ?? 0),
      hours_recorded:
        (acc[obj.date]?.hours_recorded ?? 0) + (obj?.hours_recorded ?? 0),
    };
    return acc;
  }, {});
  return Object.values(result);
};

export const mergeByHour = (...arrs: any[]) => {
  const result = arrs.flat().reduce((acc, obj) => {
    acc[obj.hour] = {
      hour: obj.hour,
      number_of_birds:
        (acc[obj.hour]?.number_of_birds ?? 0) + (obj?.number_of_birds ?? 0),
      hours_recorded:
        (acc[obj.hour]?.hours_recorded ?? 0) + (obj?.hours_recorded ?? 0),
    };
    return acc;
  }, {});

  return Object.values(result);
};

export const SpeciesDateRangeProcessing = (
  speciesDateRangeData: any,
  setSpeciesPercentageDateRange: any,
  setTotalSpeciesDetected: any,
) => {
  const result: any[] = [];
  const colors = [
    '#231B56',
    '#493E8B',
    '#C1B8D7',
    '#F1B480',
    '#F2D5B5',
    '#D18543',
    '#7D86D9',
  ];
  const totalSpeciesDetected = speciesDateRangeData!.data.reduce(
    (accumulator: any, current: any) => accumulator + current[1],
    0,
  );
  speciesDateRangeData!.data.forEach(
    (element: [string, number, number], index: number) => {
      if (index < colors.length - 1)
        result.push(createSpeciesRowData(colors[index], ...element));
      else if (index === colors.length - 1) {
        result.push(createSpeciesRowData(colors[index], 'Other', 0, 0));
        result[colors.length - 1].count += element[1];
        result[colors.length - 1].percentage =
          result[colors.length - 1].percentage + element[2];
        result.push(createSpeciesRowData('', ...element));
      } else {
        result[colors.length - 1].count += element[1];
        result[colors.length - 1].percentage =
          result[colors.length - 1].percentage + element[2];

        result.push(createSpeciesRowData('', ...element));
      }
    },
  );
  if (result.length > colors.length - 1) {
    result[colors.length - 1].percentage = Number(
      result[colors.length - 1].percentage.toFixed(2),
    );
  }
  setTotalSpeciesDetected(totalSpeciesDetected);
  setSpeciesPercentageDateRange(result);
};

export const WindSpeedDateRangeProcessing = (
  windSpeedDateRangeData: any,
  setWindSpeedCategories: any,
  setWindSpeedValues: any,
) => {
  const windSpeedCategories: any = [];
  const keys = Object.keys(windSpeedDateRangeData.data).map((key) =>
    parseInt(key),
  );
  keys.forEach((element: number) => {
    if (windSpeedIndex[element]) {
      windSpeedCategories.push(windSpeedIndex[element]);
    }
  });
  setWindSpeedCategories(windSpeedCategories);
  setWindSpeedValues(Object.values(windSpeedDateRangeData.data));
};
